import { TeacherAttendance, TeacherCheckin } from '@/plugins/api'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    teacherAttendances: [],
    pageText: '',
    itemsPerPage: 10,
    searchParams: {},
    totalItems: 0,
    loading: false,
    teacherAttendanceParams: {},
    date: moment().toISOString(),
  },
  actions: {
    async getTeacherAttendances({ commit }, { searchParams, disableSave = false }) {
      if (!disableSave) {
        commit('setTeacherAttendances', [])
      }
      commit('changeState', { teacherAttendanceParams: searchParams })
      const teacherAttendances = await TeacherAttendance.fetch(searchParams)
      if (!disableSave) {
        commit('setTeacherAttendances', teacherAttendances)
      }
      return teacherAttendances
    },
    async getAllTeacherAttendance({ commit }, { searchParams, disableSave = false }) {
      if (!disableSave) {
        commit('setTeacherAttendances', [])
      }
      const teacherAttendances = await TeacherAttendance.fetch({ ...searchParams, _limit: -1, _start: 0 })
      if (!disableSave) {
        commit('setTeacherAttendances', teacherAttendances)
      }
      return teacherAttendances
    },
    async updateTeacherAttendance({ commit }, { id, ...teacherAttendance }) {
      const response = await TeacherAttendance.update(id, teacherAttendance)
      commit('updateTeacherAttendance', response)
    },
    async checkinTeacherAttendance(_, checkinData) {
      return TeacherAttendance.checkin(checkinData)
    },
    async getTeacherAttendanceCount(_, params) {
      const teacherAttendanceCount = await TeacherAttendance.count(params)
      return teacherAttendanceCount
    },
    createTeacherCheckinAdmin(_, data) {
      return TeacherCheckin.adminCreateTeacherCheckin(data)
    },
    updateTeacherCheckinAdmin(_, { id, ...data }) {
      return TeacherCheckin.adminUpdateTeacherCheckin(id, data)
    },
    setDate({ commit }, date) {
      commit('changeState', { date })
    },
  },
  mutations: {
    setTeacherAttendances(state, teacherAttendances) {
      state.teacherAttendances = teacherAttendances
    },
    updateTeacherAttendance(state, teacherAttendance) {
      state.teacherAttendances = state.teacherAttendances.map(s => {
        if (s.id === teacherAttendance.id) {
          return { ...s, ...teacherAttendance }
        }
        return s
      })
    },
  },
  getters: {
    teacherAttendances: state => {
      return Object.values(state.teacherAttendances)
    },
  },
}
